var _g, _rect, _rect2, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 201,
  height: 140,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#70C6D1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.847 23.512a12 12 0 0 0-14.694 0L53.5 54.992h96zM101.5 92.162l48-37.17h-96z"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  x: 83.949,
  y: 67.823,
  fill: "#FDCC09",
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 22,
  x: 1,
  y: -1,
  stroke: "#FDCC09",
  strokeWidth: 2,
  rx: 9,
  transform: "matrix(1 0 0 -1 90.95 76.823)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 101.5,
  cy: 78.823,
  r: 3,
  fill: "#FEEDA7"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#BEE5EA"
}, /*#__PURE__*/React.createElement("path", {
  d: "m53.719 54.823-.219.17v-.17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m149.281 54.823.219.17-40.653 31.48a12 12 0 0 1-14.694 0L53.5 54.992v52.83c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-53z"
}))));
export { SvgEnvelope as ReactComponent };
export default __webpack_public_path__ + "8771959f1a74f467f0ee3e979de9e5d7.svg";